import { render, staticRenderFns } from "./Gant.vue?vue&type=template&id=1b10f8f2&"
import script from "./Gant.vue?vue&type=script&lang=js&"
export * from "./Gant.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports